import urlBase from 'EstruturaAntiga/assets/urlsBase';
import BaseService from './BaseService';

class PortalAuthenticationService extends BaseService {
  constructor() {
    super(urlBase.urlBase + "/authentication");
  }
}

export default PortalAuthenticationService;